import { render } from "./CardWiev.vue?vue&type=template&id=c994c44c"
import script from "./CardWiev.vue?vue&type=script&lang=js"
export * from "./CardWiev.vue?vue&type=script&lang=js"

import "./CardWiev.vue?vue&type=style&index=0&id=c994c44c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__